import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';

@Component({
  selector: 'td-wb-lti-toolbar-panel',
  templateUrl: 'lti-toolbar-panel.component.html',
  styleUrls: ['lti-toolbar-panel.component.scss'],
  imports: [
    AsyncPipe
  ]
})
export class LtiToolbarPanelComponent implements OnInit {
  private readonly mediaQueryService = inject(MediaQueryService);

  breakpointChanges$: Observable<BreakpointState>;

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.LT_MD);
  }

}

